import React, { FC } from "react";
import { BsPinAngle } from "react-icons/bs";
import { MdOutlineEdit } from "react-icons/md";

import { TrashSvg } from "../../../../components/svg/TrashSvg";
import { usePinWorkNoteMutation } from "../../../../slices/WorkNotesSlice";
import { IWorkNote } from "../../../../types/types";
import {
  mapNoteToViewModel,
  NoteCard,
  useCanEditNote,
} from "../../../contacts/components/notes";

type Props = {
  note: IWorkNote;
  onEdit: (note: IWorkNote) => void;
  onDelete: (note: IWorkNote) => void;
  onView: (note: IWorkNote) => void;
};

/** A work item note, shown like the notes on a client's Notes tab. */
export const WorkNote: FC<Props> = ({ note, onEdit, onDelete, onView }) => {
  const [pinNote, { isLoading: isLoadingPin }] = usePinWorkNoteMutation();
  const canEdit = useCanEditNote();

  return (
    <NoteCard
      // No work item chip: we're already on the work item.
      note={{ ...mapNoteToViewModel(note), workId: undefined }}
      onView={() => onView(note)}
      actions={[
        ...(canEdit(note)
          ? [
              {
                name: "Edit",
                action: () => onEdit(note),
                icon: <MdOutlineEdit size={20} />,
              },
            ]
          : []),
        {
          name: note.isPinned ? "Unpin" : "Pin",
          action: () => {
            if (!isLoadingPin) {
              pinNote({ id: note.id, isPinned: !note.isPinned });
            }
          },
          icon: <BsPinAngle size={20} />,
        },
        {
          name: "Delete",
          action: () => onDelete(note),
          icon: <TrashSvg />,
          extraClasses: "text-[#DC2626]",
          iconColor: "text-[#DC2626]",
        },
      ]}
    />
  );
};
